// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"55743fa4","369":"1c8ddde6","416":"433f95c3","806":"d4b2be82","965":"adb7bdc0"}[chunkId] + ".chunk.js";
};